import type { Theme } from '@mui/material';
function getAvatarStyle(theme: Theme) {
	return {
		left: '50%',
		position: 'relative',
		transform: 'translateX(-50%)',
		backgroundColor: 'hsl(200, 21%, 92%)',
		borderRadius: '100%',
		height: '140px',
		width: '140px',
		fontSize: '56px',
		color: theme.palette.tsGoColor.black,
	};
}

function getMiniAvatarStyle() {
	return {
		left: '20px',
		position: 'absolute',
		transform: 'translateX(-50%)',
		borderRadius: '100%',
		height: '40px',
		width: '40px',
	};
}

function getSidebarAvatarStyle() {
	return {
		left: '20px',
		position: 'relative',
		transform: 'translateX(-50%)',
		borderRadius: '100%',
		height: '40px',
		width: '40px',
	};
}

export const muiAvatarOverrides = {
	styleOverrides: {
		root: ({ theme }) => {
			return {
				variants: [
					{
						props: {
							'ts-variant': 'profile',
						},
						style: getAvatarStyle(theme),
					},
					{
						props: {
							'ts-variant': 'minicircular',
						},
						style: getMiniAvatarStyle(),
					},
					{
						props: {
							'ts-variant': 'circularsidebar',
						},
						style: getSidebarAvatarStyle(),
					},
				],
			};
		},
	},
};
